module.exports = __webpack_public_path__ + "img/case-logo-11.172f28f4.png";